import { DivPenddingSearch } from "./AdminReportStyle";
import ICPendingSearch from "../../images/icon_pending_search_table.svg";

export const SearchGetRegister = () => {
  return (
    <DivPenddingSearch>
      <img src={ICPendingSearch} alt="" />
      <div className="pendding-text">
        <span>Realiza una búsqueda para obtener registros</span>
      </div>
    </DivPenddingSearch>
  );
};
